var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcVerifiedUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16h16V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D8AE",
    d: "M8 1.334a6.666 6.666 0 110 13.333A6.666 6.666 0 018 1.334zm3.328 4.29a.668.668 0 00-.943 0L7.047 8.963 5.614 7.529a.668.668 0 00-.943.943l2.376 2.376 4.28-4.281a.666.666 0 000-.943z"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg%3E %3Cg%3E %3Cg%3E %3Cg%3E %3Cpath d='M0 16L16 16 16 0 0 0z' transform='translate(-637 -109) translate(516 104) translate(45 1) translate(76 4)'/%3E %3Cpath fill='%2300D8AE' d='M8 1.334c3.682 0 6.666 2.985 6.666 6.666 0 3.682-2.984 6.667-6.666 6.667-3.682 0-6.667-2.985-6.667-6.667C1.333 4.32 4.318 1.334 8 1.334zm3.328 4.29c-.26-.26-.682-.26-.943 0L7.047 8.963 5.614 7.529c-.261-.26-.682-.26-.943 0-.26.26-.26.682 0 .943l2.376 2.376 4.28-4.281c.261-.26.261-.682 0-.943z' transform='translate(-637 -109) translate(516 104) translate(45 1) translate(76 4)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcVerifiedUnfilled as ReactComponent };